module.exports = __webpack_public_path__ + "img/ico_social_twitter--white.d65e2483.svg";